module.exports = __webpack_public_path__ + "img/discover-1kpx.3d2d5515.png";